var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbMessenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 36.1791C31.1797 36.1791 37 30.5426 37 23.5896C37 16.6365 31.1797 11 24 11C16.8203 11 11 16.6365 11 23.5896C11 27.3712 12.7217 30.7634 15.4474 33.0711V35.6188C15.4474 36.6145 16.4616 37.2824 17.3659 36.8821L20.193 35.6307C21.397 35.9873 22.6754 36.1791 24 36.1791Z",
    fill: "url(#paint0_linear_8204_252020)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.887 20.9133L17.1172 26.0689C16.713 26.6217 17.4399 27.2858 17.9933 26.8693L21.2123 24.4469C21.5399 24.2003 21.9992 24.197 22.3307 24.4388L25.1935 26.5272C25.7425 26.9277 26.5272 26.8125 26.9269 26.2727L30.8805 20.9341C31.2905 20.3804 30.558 19.7109 30.0038 20.1328L26.6006 22.7236C26.2729 22.9731 25.8112 22.9777 25.4782 22.7347L22.6247 20.6531C22.0733 20.2509 21.285 20.369 20.887 20.9133Z",
    fill: "#F5F5F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8204_252020",
    x1: 24,
    y1: 11,
    x2: 19.8286,
    y2: 36.8583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006BFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbMessenger);
export default __webpack_public_path__ + "static/media/fb_messenger.107312172e9e178418047cd3119e70af.svg";
export { ForwardRef as ReactComponent };